export const Skillsdata=[
    {
        type:"Front End",
        list:[{
            name:"React",
            icon:<i class="devicon-react-original colored"></i>
        },
        {
            name:"Redux",
            icon:<i class="devicon-redux-original colored"></i>
        },
        {
            name:"HTML",
            icon:<i class="devicon-html5-plain"></i>
        },
        {
            name:"CSS",
            icon:<i class="devicon-css3-plain colored"></i>
        },
        {
            name:"Java Script",
            icon:<i class="devicon-javascript-plain colored"></i>
        },
        {
            name:"Material UI",
            icon:<i class="devicon-materialui-plain colored"></i>
        },
        {
            name:"Dev icon",
            icon:<i class="devicon-devicon-plain"></i>
        },
        {
            name:"Typescript",
            icon:<i class="devicon-typescript-plain"></i>
        },
        {
            name:"Tailwind CSS",
            icon:
            <i class="devicon-tailwindcss-original-wordmark"></i>
          
        },
        
        
    
    ]

    },
    {
        type:"Back End",
        list:[{
            name:"Node Js",
            icon:<i class="devicon-nodejs-plain-wordmark colored"></i>
        },
        {
            name:"Express Js",
            icon:<i class="devicon-express-original-wordmark colored"></i>
        },
        {
            name:"Mongoose",
            icon:<i class="devicon-mongodb-plain colored"></i>
        },

        {
            name:"Mongo DB",
            icon:<i class="devicon-mongodb-plain colored"></i>
        },
        {
            name:"NPM",
            icon:<i class="devicon-npm-original-wordmark colored"></i>
        },
    ]
    }
    
]